import { DeleteOutlined, EllipsisOutlined } from '@ant-design/icons'
import {
  Button,
  ButtonProps,
  Dropdown,
  DropDownProps,
  DropdownProps,
  MenuProps,
} from 'antd'
import React, { ReactNode, useState } from 'react'

type Props = {
  onDelete?: () => Promise<void> | void
  items: MenuProps['items']
  props?: DropDownProps
  propsButton?: ButtonProps
  children?: ReactNode
}

export const DropdownWithDelete: React.FC<Props> = ({
  onDelete,
  items = [],
  props = {},
  propsButton = {},
  children,
}) => {
  const [isLoadingDelete, setLoadingDelete] = useState(false)
  const [isDeleteConfirm, setDeleteConfirm] = useState(false)
  const [open, setOpen] = useState(false)

  const handleMenuClick: MenuProps['onClick'] = event => {
    if (event.key === 'delete' && !isDeleteConfirm) {
      return
    }

    setOpen(false)
  }

  const handleOpenChange: DropdownProps['onOpenChange'] = (nextOpen, info) => {
    if (info.source === 'trigger' || nextOpen) {
      setOpen(nextOpen)
    }

    if (info.source === 'trigger' && !nextOpen) {
      setDeleteConfirm(false)
    }
  }

  const handleClickDelete = async () => {
    if (isDeleteConfirm) {
      if (!isLoadingDelete) {
        setLoadingDelete(true)

        await onDelete()

        setLoadingDelete(false)
      }
    } else {
      setDeleteConfirm(true)
    }
  }

  return (
    <Dropdown
      {...props}
      menu={{
        style: { minWidth: '150px' },
        onClick: handleMenuClick,
        items: [
          ...items,
          onDelete && {
            key: 'delete',
            label: isDeleteConfirm ? 'Really delete?' : 'Delete',
            danger: true,
            icon: <DeleteOutlined />,

            onClick: handleClickDelete,
          },
        ].filter(option => !!option),
      }}
      onOpenChange={handleOpenChange}
      open={open}
      trigger={['click']}
    >
      {children ? (
        children
      ) : (
        <Button
          size="large"
          type="text"
          icon={<EllipsisOutlined style={{ transform: 'rotate(90deg)' }} />}
          {...propsButton}
          loading={isLoadingDelete}
        />
      )}
    </Dropdown>
  )
}
